import { axios } from '@/services/axios';

const indicateActionPlatformNumber = async (numberId, platformId, scope) => {
    const res = await axios.post(
        `/PlatformNumber/${numberId}/Platform/${platformId}/Actioned`,
        {
            headers: {
                'X-RequestScope': scope,
            },
        },
    );
    return res.data;
};
export default indicateActionPlatformNumber;
